import { z } from 'zod';

export const asaasEnvironmentSchema = z.enum(['sandbox', 'production']);
export type AsaasEnvironmentSchema = z.infer<typeof asaasEnvironmentSchema>;

export const asaasAccountStatusSchema = z.enum(['active', 'paused', 'disabled']);
export type AsaasAccountStatusSchema = z.infer<typeof asaasAccountStatusSchema>;

const namePattern = z.string().min(1, 'Nome obrigatório.').max(120, 'Nome até 120 caracteres.');
const webhookPathPattern = z
  .string()
  .min(1, 'Webhook path obrigatório.')
  .max(80, 'Webhook path até 80 caracteres.')
  .regex(
    /^[a-z0-9-]+$/,
    'Webhook path aceita apenas lowercase, dígitos e hífen (ex: "owl-master").',
  );
const apiKeyPattern = z
  .string()
  .min(10, 'API key parece curta demais (mínimo 10 caracteres).')
  .max(500, 'API key até 500 caracteres.');
const webhookSecretPattern = z
  .string()
  .min(8, 'Webhook secret mínimo 8 caracteres.')
  .max(500, 'Webhook secret até 500 caracteres.');

const lateFeeConfigSchema = z
  .object({
    interest_percent_month: z.number().nonnegative().max(50).optional(),
    fine_percent: z.number().nonnegative().max(50).optional(),
    grace_days: z.coerce.number().int().nonnegative().max(60).optional(),
  })
  .strict()
  .partial();

export const createAsaasAccountSchema = z.object({
  name: namePattern,
  environment: asaasEnvironmentSchema,
  api_key: apiKeyPattern,
  webhook_secret: webhookSecretPattern,
  webhook_path: webhookPathPattern,
  is_default: z.coerce.boolean().default(false),
  status: asaasAccountStatusSchema.default('active'),
  late_fee_config: lateFeeConfigSchema.optional(),
});
export type CreateAsaasAccountDto = z.output<typeof createAsaasAccountSchema>;
export type CreateAsaasAccountInput = z.input<typeof createAsaasAccountSchema>;

export const updateAsaasAccountSchema = z
  .object({
    name: namePattern.optional(),
    environment: asaasEnvironmentSchema.optional(),
    api_key: apiKeyPattern.optional(),
    webhook_secret: webhookSecretPattern.optional(),
    webhook_path: webhookPathPattern.optional(),
    is_default: z.coerce.boolean().optional(),
    status: asaasAccountStatusSchema.optional(),
    late_fee_config: lateFeeConfigSchema.optional().nullable(),
  })
  .strict()
  .refine((data) => Object.keys(data).length > 0, {
    message: 'Pelo menos um campo deve ser informado.',
  });
export type UpdateAsaasAccountDto = z.output<typeof updateAsaasAccountSchema>;
export type UpdateAsaasAccountInput = z.input<typeof updateAsaasAccountSchema>;

export const queryAsaasAccountsSchema = z
  .object({
    status: asaasAccountStatusSchema.optional(),
    environment: asaasEnvironmentSchema.optional(),
  })
  .strict();
export type QueryAsaasAccountsDto = z.output<typeof queryAsaasAccountsSchema>;
